import InputTag, { InputTagProps } from './input-tag';

export default InputTag;
export { InputTagProps };
